document.addEventListener("turbolinks:load", (event) => {
  let achievedBy = document.querySelectorAll("[data-toggle-achieved-by]");

  achievedBy.forEach((achieved) => {
    const checkbox = achieved.querySelector("input[type=checkbox]");
    const next = achieved.nextElementSibling;
    next.style.display = checkbox.checked ? "block" : "none";
    checkbox.addEventListener("change", (e) => {
      next.style.display = e.target.checked ? "block" : "none";
    });
  });
});
